var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006a4e",
    d: "M0 0h512v512H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 256,
    r: 170.7,
    fill: "#f42a41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBd);
export default __webpack_public_path__ + "static/media/bd.5ec0fab3bc8aa5078e1610b715b7427c.svg";
export { ForwardRef as ReactComponent };